import { useState } from 'react';

import useTranslations from '@/i18n/useTranslations';
import GoBackButton from '@/shared-components/buttons/components/GoBackButton';

import '../../artist-help/profile/styles.css';

export default function ProfileGalleryHelpAdminModePage() {
  const t = useTranslations('galleries_help.admin_mode');
  const [openSections, setOpenSections] = useState({
    twoPlatforms: false,
    workspacePreferences: false,
    home: false,
    artists: false,
    artworks: false,
    otherProducts: false,
    shipping: false,
    commissions: false,
    expenses: false,
    sales: false,
    members: false,
    exhibitions: false,
    contacts: false,
    addInvoices: false,
    suarteInvoices: false,
    aiProfile: false,
    support: false,
  });

  function toggleSection(sectionKey) {
    setOpenSections((previous) => ({
      ...previous,
      [sectionKey]: !previous[sectionKey],
    }));
  }

  return (
    <section className="artist-help-category gallery-help-category">
      <header className="artist-help-category__header gallery-help-category__header">
        <GoBackButton alternativeRoute="/profile/gallery-help" />
        <h1>{t('title')}</h1>
      </header>

      <div className="artist-help-category__body gallery-help-category__body">
        <section className="artist-help-category__card artist-help-category__accordion gallery-help-category__card gallery-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger gallery-help-category__accordion-trigger"
            onClick={() => toggleSection('twoPlatforms')}
            aria-expanded={openSections.twoPlatforms}
          >
            <h2>{t('sections.two_platforms.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon gallery-help-category__accordion-icon ${openSections.twoPlatforms ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.twoPlatforms && (
            <div className="artist-help-category__accordion-content gallery-help-category__accordion-content">
              <p>{t('sections.two_platforms.intro')}</p>
              <ul>
                <li>
                  <strong>{t('sections.two_platforms.social_marketplace_title')}:</strong>{' '}
                  {t('sections.two_platforms.social_marketplace_body')}
                </li>
                <li>
                  <strong>{t('sections.two_platforms.management_workspace_title')}:</strong>{' '}
                  {t('sections.two_platforms.management_workspace_body')}
                </li>
              </ul>
              <p>{t('sections.two_platforms.p2')}</p>
              <p>{t('sections.two_platforms.p3')}</p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion gallery-help-category__card gallery-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger gallery-help-category__accordion-trigger"
            onClick={() => toggleSection('workspacePreferences')}
            aria-expanded={openSections.workspacePreferences}
          >
            <h2>{t('sections.workspace_preferences.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon gallery-help-category__accordion-icon ${openSections.workspacePreferences ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.workspacePreferences && (
            <div className="artist-help-category__accordion-content gallery-help-category__accordion-content">
              <p>{t('sections.workspace_preferences.p1')}</p>
              <p>{t('sections.workspace_preferences.p2')}</p>
              <p>{t('sections.workspace_preferences.p3')}</p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion gallery-help-category__card gallery-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger gallery-help-category__accordion-trigger"
            onClick={() => toggleSection('home')}
            aria-expanded={openSections.home}
          >
            <h2>{t('sections.home.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon gallery-help-category__accordion-icon ${openSections.home ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.home && (
            <div className="artist-help-category__accordion-content gallery-help-category__accordion-content">
              <p>{t('sections.home.p1')}</p>
              <p>{t('sections.home.p2')}</p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion gallery-help-category__card gallery-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger gallery-help-category__accordion-trigger"
            onClick={() => toggleSection('artists')}
            aria-expanded={openSections.artists}
          >
            <h2>{t('sections.artists.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon gallery-help-category__accordion-icon ${openSections.artists ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.artists && (
            <div className="artist-help-category__accordion-content gallery-help-category__accordion-content">
              <p>{t('sections.artists.p1')}</p>
              <p>{t('sections.artists.p2')}</p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion gallery-help-category__card gallery-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger gallery-help-category__accordion-trigger"
            onClick={() => toggleSection('artworks')}
            aria-expanded={openSections.artworks}
          >
            <h2>{t('sections.artworks.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon gallery-help-category__accordion-icon ${openSections.artworks ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.artworks && (
            <div className="artist-help-category__accordion-content gallery-help-category__accordion-content">
              <p>{t('sections.artworks.p1')}</p>
              <p>{t('sections.artworks.p2')}</p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion gallery-help-category__card gallery-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger gallery-help-category__accordion-trigger"
            onClick={() => toggleSection('otherProducts')}
            aria-expanded={openSections.otherProducts}
          >
            <h2>{t('sections.other_products.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon gallery-help-category__accordion-icon ${openSections.otherProducts ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.otherProducts && (
            <div className="artist-help-category__accordion-content gallery-help-category__accordion-content">
              <p>{t('sections.other_products.p1')}</p>
              <p>{t('sections.other_products.p2')}</p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion gallery-help-category__card gallery-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger gallery-help-category__accordion-trigger"
            onClick={() => toggleSection('shipping')}
            aria-expanded={openSections.shipping}
          >
            <h2>{t('sections.shipping.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon gallery-help-category__accordion-icon ${openSections.shipping ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.shipping && (
            <div className="artist-help-category__accordion-content gallery-help-category__accordion-content">
              <p>{t('sections.shipping.p1')}</p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion gallery-help-category__card gallery-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger gallery-help-category__accordion-trigger"
            onClick={() => toggleSection('commissions')}
            aria-expanded={openSections.commissions}
          >
            <h2>{t('sections.commissions.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon gallery-help-category__accordion-icon ${openSections.commissions ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.commissions && (
            <div className="artist-help-category__accordion-content gallery-help-category__accordion-content">
              <p>{t('sections.commissions.p1')}</p>
              <p>{t('sections.commissions.p2')}</p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion gallery-help-category__card gallery-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger gallery-help-category__accordion-trigger"
            onClick={() => toggleSection('expenses')}
            aria-expanded={openSections.expenses}
          >
            <h2>{t('sections.expenses.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon gallery-help-category__accordion-icon ${openSections.expenses ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.expenses && (
            <div className="artist-help-category__accordion-content gallery-help-category__accordion-content">
              <p>{t('sections.expenses.p1')}</p>
              <p>{t('sections.expenses.p2')}</p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion gallery-help-category__card gallery-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger gallery-help-category__accordion-trigger"
            onClick={() => toggleSection('sales')}
            aria-expanded={openSections.sales}
          >
            <h2>{t('sections.sales.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon gallery-help-category__accordion-icon ${openSections.sales ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.sales && (
            <div className="artist-help-category__accordion-content gallery-help-category__accordion-content">
              <p>{t('sections.sales.p1')}</p>
              <p>{t('sections.sales.p2')}</p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion gallery-help-category__card gallery-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger gallery-help-category__accordion-trigger"
            onClick={() => toggleSection('members')}
            aria-expanded={openSections.members}
          >
            <h2>{t('sections.members.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon gallery-help-category__accordion-icon ${openSections.members ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.members && (
            <div className="artist-help-category__accordion-content gallery-help-category__accordion-content">
              <p>{t('sections.members.p1')}</p>
              <p>{t('sections.members.p2')}</p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion gallery-help-category__card gallery-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger gallery-help-category__accordion-trigger"
            onClick={() => toggleSection('exhibitions')}
            aria-expanded={openSections.exhibitions}
          >
            <h2>{t('sections.exhibitions.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon gallery-help-category__accordion-icon ${openSections.exhibitions ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.exhibitions && (
            <div className="artist-help-category__accordion-content gallery-help-category__accordion-content">
              <p>{t('sections.exhibitions.p1')}</p>
              <p>{t('sections.exhibitions.p2')}</p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion gallery-help-category__card gallery-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger gallery-help-category__accordion-trigger"
            onClick={() => toggleSection('contacts')}
            aria-expanded={openSections.contacts}
          >
            <h2>{t('sections.contacts.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon gallery-help-category__accordion-icon ${openSections.contacts ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.contacts && (
            <div className="artist-help-category__accordion-content gallery-help-category__accordion-content">
              <p>{t('sections.contacts.p1')}</p>
              <p>{t('sections.contacts.p2')}</p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion gallery-help-category__card gallery-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger gallery-help-category__accordion-trigger"
            onClick={() => toggleSection('addInvoices')}
            aria-expanded={openSections.addInvoices}
          >
            <h2>{t('sections.add_invoices.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon gallery-help-category__accordion-icon ${openSections.addInvoices ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.addInvoices && (
            <div className="artist-help-category__accordion-content gallery-help-category__accordion-content">
              <p>{t('sections.add_invoices.p1')}</p>
              <p>{t('sections.add_invoices.p2')}</p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion gallery-help-category__card gallery-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger gallery-help-category__accordion-trigger"
            onClick={() => toggleSection('suarteInvoices')}
            aria-expanded={openSections.suarteInvoices}
          >
            <h2>{t('sections.suarte_invoices.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon gallery-help-category__accordion-icon ${openSections.suarteInvoices ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.suarteInvoices && (
            <div className="artist-help-category__accordion-content gallery-help-category__accordion-content">
              <p>{t('sections.suarte_invoices.p1')}</p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion gallery-help-category__card gallery-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger gallery-help-category__accordion-trigger"
            onClick={() => toggleSection('aiProfile')}
            aria-expanded={openSections.aiProfile}
          >
            <h2>{t('sections.ai_profile.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon gallery-help-category__accordion-icon ${openSections.aiProfile ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.aiProfile && (
            <div className="artist-help-category__accordion-content gallery-help-category__accordion-content">
              <p>{t('sections.ai_profile.p1')}</p>
              <p>{t('sections.ai_profile.p2')}</p>
            </div>
          )}
        </section>

        <section className="artist-help-category__card artist-help-category__accordion gallery-help-category__card gallery-help-category__accordion">
          <button
            type="button"
            className="artist-help-category__accordion-trigger gallery-help-category__accordion-trigger"
            onClick={() => toggleSection('support')}
            aria-expanded={openSections.support}
          >
            <h2>{t('sections.support.title')}</h2>
            <span
              className={`artist-help-category__accordion-icon gallery-help-category__accordion-icon ${openSections.support ? 'open' : ''}`}
              aria-hidden
            />
          </button>

          {openSections.support && (
            <div className="artist-help-category__accordion-content gallery-help-category__accordion-content">
              <p>{t('sections.support.p1')}</p>
              <p>{t('sections.support.p2')}</p>
            </div>
          )}
        </section>
      </div>
    </section>
  );
}
